export default __webpack_public_path__ + "490065792b7e903c9f3ee3ddd38bd5cb.svg";